import React from 'react';
import moment from 'moment';
import forOwn from 'lodash/forOwn';
import find from 'lodash/find';
import ReactTooltip from 'react-tooltip';

import classes from '../components/FormNumberRange/FormNumberRange.scss';

export const fieldTypes = [
  {
    value: 'string',
    label: 'Zeichenkette',
  },
  {
    value: 'date',
    label: 'Datum',
  },
  {
    value: 'interval',
    label: 'Intervall',
  },
  {
    value: 'seperator',
    label: 'Trennzeichen',
  },
];

export const seperators = [
  {
    value: '.',
    label: '. (Punkt)',
  },
  {
    value: ',',
    label: ', (Komma)',
  },
  {
    value: '-',
    label: '- (Bindestrich)',
  },
  {
    value: '_',
    label: '_ (Unterstrich)',
  },
  {
    value: ' ',
    label: 'Leerzeichen',
  },
  {
    value: '\\',
    label: '\\ (Backslash)',
  },
];

export const dates = [
  {
    value: 'Y',
    label: 'Jahreszahl (vierstellig)',
  },
  {
    value: 'y',
    label: 'Jahreszahl (zweistellig)',
  },
  {
    value: 'm',
    label: 'Monat',
  },
  {
    value: 'd',
    label: 'Tag',
  },
];

export const renderDate = dateString => {
  const momentEquivalent = {
    Y: 'YYYY',
    y: 'YY',
    m: 'MM',
    d: 'DD',
  };
  const now = moment();

  let renderedDate = '';
  forOwn(momentEquivalent, (momentFormat, phpFormat) => {
    if (phpFormat === dateString) {
      renderedDate = now.format(momentFormat);
    }
  });

  return renderedDate;
};

/**
 * Prepend $number with $n '0's
 *
 * @param number
 * @param n
 * @returns {string}
 */
export const pad = (number, n) => {
  n = typeof n === 'undefined' || n <= 0 || isNaN(n) ? 1 : n;
  number = isNaN(number) ? 0 : number;
  const numberLength = parseInt(number, 10).toString().length;
  const calculatedLength = n - numberLength + 1;
  n = calculatedLength < 0 ? 0 : calculatedLength;
  return new Array(n).join('0').slice((n || 2) * -1) + number;
};

export const renderPreview = (
  rawFields,
  showHeader,
  id,
  withTooltip,
  plain,
) => {
  const fields = [];
  showHeader = typeof showHeader === 'undefined' ? false : showHeader;
  withTooltip = typeof withTooltip === 'undefined' ? false : withTooltip;
  plain = typeof plain === 'undefined' ? false : plain;

  rawFields.forEach((field, index) => {
    let value = field.value;
    let key = `numberrange_field_${index}`;
    let fieldClasses = classes.formatField;

    if (typeof id !== 'undefined') {
      key = `numberrange_${id}_field_${index}`;
    }

    let start = null;
    let end = null;
    let length = null;
    let current = null;
    if (field.type === 'interval') {
      start = parseInt(field.value.start, 10);
      length = parseInt(field.value.start, 10).toString().length;

      if (typeof field.value.end !== 'undefined') {
        length = parseInt(field.value.end, 10).toString().length;
      }

      if (
        typeof field.value.length !== 'undefined' &&
        !isNaN(field.value.length)
      ) {
        length = parseInt(field.value.length, 10);
      }

      let currentValue = start;
      if (
        typeof field.value.current !== 'undefined' &&
        !isNaN(field.value.current)
      ) {
        currentValue = parseInt(field.value.current, 10) + 1;
      }

      currentValue = isNaN(currentValue) ? 1 : currentValue;

      value = pad(currentValue, length);
      end = parseInt(field.value.end, 10);
      current = parseInt(field.value.current, 10);
    }

    if (field.type === 'date') {
      value = renderDate(field.value);
    }

    if (field.type === 'seperator') {
      fieldClasses = `${classes.formatField} ${classes.seperator}`;
    }

    const tooltipId = `numberrange_${id}_format_field_${index}_tooltip`;
    const typeLabelObject = find(fieldTypes, { value: field.type });
    const typeLabel =
      typeof typeLabelObject !== 'undefined' ? typeLabelObject.label : '';
    const tooltipValue = field.type === 'string' ? `"${value}"` : value;
    let tooltipContent = `${typeLabel}: <code>${tooltipValue}</code>`;
    if (field.type === 'interval') {
      tooltipContent = `${typeLabel}: <code>${start}</code> bis <code>${end}</code>`;

      if (!isNaN(current)) {
        tooltipContent += ` (aktuell: <code>${current}</code>)`;
      }
    }
    const tooltipHtml =
      withTooltip === true && field.type !== 'seperator' ? (
        <ReactTooltip
          id={tooltipId}
          className={classes.tooltip}
          place="top"
          type="dark"
          effect="solid"
          html
        />
      ) : null;

    if (value !== '') {
      if (plain === true) {
        fields.push(value);
      } else {
        fields.push(
          <li
            key={key}
            className={fieldClasses}
            data-tip={tooltipContent}
            data-for={tooltipId}
          >
            {value}
            {tooltipHtml}
          </li>,
        );
      }
    }
  });

  if (fields.length && showHeader === true) {
    let headerKey = 'numberrange_fieldlist_header';
    if (typeof id !== 'undefined') {
      headerKey = `numberrange_${id}_fieldlist_header`;
    }

    fields.unshift(
      <li key={headerKey} className={classes.formatListHeader}>
        Vorschau:
      </li>,
    );
  }

  return fields;
};



// WEBPACK FOOTER //
// ./src/models/NumberRange.js